import React, { Fragment } from "react";
import PropTypes from "prop-types";
import I18N from "../../I18N";
import { TestBox } from "../index";
import { ReactComponent as UploadDownload } from "../../assets/imgs/upload-download.svg";
import "./speedTest.scss";

const SpeedTest = ({ result, handleReTest }) => {
  const buttonRef = React.createRef();
  const { upload, download, isLoading } = result;
  return (
    <TestBox
      testName={I18N.t("SPEED_TEST")}
      handleReTest={handleReTest}
      buttonRef={buttonRef}
      isLoading={isLoading}
    >
      <div className="speed-test">
        {upload ? (
          <Fragment>
            <p>{upload}</p>
            <UploadDownload />
            <p>{download}</p>
          </Fragment>
        ) : (
          <button
            className="speed-test__start-test-button"
            onClick={() => {
              if (buttonRef && buttonRef.current) {
                buttonRef.current.click();
              }
            }}
          >
            {I18N.t("SPEED_TEST")}
          </button>
        )}
      </div>
    </TestBox>
  );
};

SpeedTest.propTypes = {};
SpeedTest.defaultProps = {};

export default SpeedTest;
